import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { Cross } from '../icon/icon-map';

@Component({
  selector: 'phx-bottom-sheet',
  templateUrl: './phx-bottom-sheet.component.html',
  styleUrls: ['./phx-bottom-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-bottom-sheet',
  },
})
export class PhxBottomSheetComponent {
  @Input() phxExpanded: boolean = false;
  @Input() phxPeekHeight: number = 92;
  @Input() phxTopOffset: number = 80;
  @Input() phxHideCloseIcon: boolean = false;
  @Input() phxAutoClose: boolean = true;

  @Output() phxExpandedChange = new EventEmitter<boolean>();
  @Output() phxBackdropClicked = new EventEmitter<void>();
  @Output() phxDismissAttempt = new EventEmitter<void>();
  @Output() phxCloseIconClicked = new EventEmitter<void>();

  readonly CloseIcon = Cross;

  onCloseClick(): void {
    this.phxCloseIconClicked.emit();
    if (this.phxAutoClose) {
      this.setExpanded(false);
    }
  }

  setExpanded(expanded: boolean): void {
    if (this.phxExpanded === expanded) return;
    this.phxExpanded = expanded;
    this.phxExpandedChange.emit(expanded);
  }
}
